import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function WhyAlma() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="why-title" className="bg-white py-24 md:py-28" data-id="element-378" data-mp="3msbtufpsdzcb">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-379" data-mp="3rlo57o5gg9n4">
        <h2 id="why-title" className="font-display text-[30px] font-medium leading-[1.2] tracking-[-0.01em] text-ink md:text-[36px] lg:col-span-4" data-id="element-380" data-mp="3vmgj4up9v2pq">
          {t.why.title}
        </h2>
        <ul className="grid gap-x-12 sm:grid-cols-2 lg:col-span-8" data-id="element-381" data-mp="33vttxb0sat4z">
          {t.why.items.map(item => <li key={item.title} className="border-t border-mist py-6" data-id="element-382" data-mp="37v2ouj7k8x24">
              <h3 className="flex items-center gap-3 font-display text-[17px] font-medium text-ink" data-id="element-383" data-mp="3cvyzdfmf3hgi">
                <span aria-hidden="true" className="h-1.5 w-1.5 rotate-45 bg-violet" data-id="element-384" data-mp="n5da066uxb9f" />
                {item.title}
              </h3>
              <p className="mt-2 pl-[18px] text-[15.5px] text-muted" data-id="element-385" data-mp="s3n7wojyupyq">{item.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}